import { AlertDialog, AlertDialogBody, AlertDialogCloseButton, AlertDialogContent, AlertDialogFooter, AlertDialogHeader, AlertDialogOverlay, Box, Button, Text } from "@chakra-ui/react";

export default function ModalConfirm({isOpen, onClose, onConfirm, title = '', desc = ''}) {
  return (
      <AlertDialog motionPreset='slideInBottom' onClose={onClose} isOpen={isOpen} isCentered>
          <AlertDialogOverlay />

          <AlertDialogContent>
              <AlertDialogHeader fontWeight={600}>{title}</AlertDialogHeader>
              <AlertDialogCloseButton />
              <AlertDialogBody>
                  <Box>
                      <Text>{desc}</Text>
                  </Box>
              </AlertDialogBody>
              <AlertDialogFooter mt={5}>
                  <Button onClick={onClose} size='lg' fontSize='15px'>
                      Close
                  </Button>
                  <Button
                      size='lg'
                      fontSize='15px'
                      colorScheme='primary'
                      ml={3}
                      onClick={onConfirm}>
                      Confirm
                  </Button>
              </AlertDialogFooter>
          </AlertDialogContent>
      </AlertDialog>
  );
}
